import { routes } from "routes";
import {
  getAuthToken,
  getSelfVerificationRequestIdUsingToken,
  initAuthorization,
  setAuthorization,
} from "./apis";
import { getSessionStorageItem, setSessionStorageItem } from "./storageService";
import { decodeJwt } from "utils/utils";
import { store } from "app/store";
import {
  signIn as signInAction,
  signOut as signOutAction,
} from "features/auth/authSlice";
import { showAlert } from "features/modal/modalSlice";
import { showSnackBar } from "features/snackbar/snackbarSlice";
import { showExpireAlert } from "features/expireAlert/expireAlertSlice";
import { hideLoading } from "features/loading/loadingSlice";

export const getServiceURL = () => {
  return window.location.origin;
};

// code 값으로 로그인 (회원가입 시 사용됨)
export const signInUsingCode = async (
  code,
  navigate,
  redirectURI,
  message,
  shouldPostMessage = false,
) => {
  const response = await getAuthToken(code);
  const {
    data: { success, data, message: errorMessage },
  } = response;

  if (success) {
    const { authToken } = data;
    const {
      name,
      roles = "NONE",
      sns,
      sub = "",
      version = "",
    } = decodeJwt(authToken);
    const ids = sub.split(":");

    // 본인인증 완료한 회원
    if (+ids[1]) {
      await signInUsingToken(
        authToken,
        navigate,
        redirectURI,
        message,
        shouldPostMessage,
      );
    } else {
      // 팝업(간편 로그인) 플로우에서 본인인증이 필요한 경우, 본인인증 완료 후에도
      // 팝업임을 알 수 있도록 sessionStorage에 마킹
      if (shouldPostMessage) {
        sessionStorage.setItem("is_simple_login_popup", "true");
      }
      requestSelfVerification(authToken);
    }
  } else {
    store.dispatch(showAlert({ message: errorMessage }));
    navigate && navigate(routes.home);
  }
};

// token 값으로 로그인
export const signInUsingToken = (
  token,
  navigate,
  redirectURI,
  message,
  shouldPostMessage = false,
) => {
  setSessionStorageItem("accessToken", token);
  setAuthorization(token);

  // 간편 로그인을 위해 외부 페이지로 이동했을 때,
  if (shouldPostMessage) {
    let accessToken = getSessionStorageItem("accessToken");
    // Safari 생체 인증(Face ID/Touch ID)은 response_mode=form_post로 팝업이 크로스 오리진을
    // 여러 번 이동하면서 window.opener가 null이 되는 경우가 있음
    if (window.opener) {
      window.opener.postMessage(
        {
          type: "simple_login",
          accessToken,
        },
        getServiceURL(),
      );
    } else {
      localStorage.setItem("simple_login_token", accessToken);
    }
    window.close();
    return;
  }

  const { name, sub = "", roles = "", version = "" } = decodeJwt(token);
  const ids = sub.split(":");
  const roleList = roles.split(",");
  store.dispatch(
    signInAction({
      name,
      userId: ids[1],
      socialId: ids[0],
      roles: roleList,
      version,
    }),
  );
  message && store.dispatch(showSnackBar({ message }));

  navigate &&
    navigate(
      redirectURI === "null" || redirectURI === undefined || redirectURI === ""
        ? routes.home
        : redirectURI,
      { replace: true },
    );
};

export const signOut = () => {
  setSessionStorageItem("accessToken", "");
  initAuthorization();
  // Safari Apple 로그인 fallback에서 사용하는 localStorage 잔류값 정리
  // (정리하지 않으면 LoginButtons가 마운트될 때 잔류 토큰으로 자동 로그인됨)
  localStorage.removeItem("simple_login_token");
  localStorage.removeItem("simple_signup_requestId");
  store.dispatch(signOutAction());
};

// 본인인증 요청
export const requestSelfVerification = (token) => {
  getSelfVerificationRequestIdUsingToken({ purpose: "SIGNUP" }, token).then(
    ({ data: { requestId } }) => {
      window.location.href = `${process.env.REACT_APP_API_URL}/api/v1/mall/verification/self/start?requestId=${requestId}`;
    },
  );
};

// 토큰 만료 ( 401 )
export const expireAuth = () => {
  signOut();
  // 만료 시점에 진행 중이던 API가 dispatch(showLoading)을 호출한 상태였을 수 있음.
  // Loading의 z-index(2000)가 ExpireAlert(1010/1020)보다 높아서 Loading이 남아있으면
  // 만료 팝업을 가려 사용자가 닫을 수 없게 됨. 명시적으로 hideLoading을 호출하여 방어.
  store.dispatch(hideLoading());
  store.dispatch(showExpireAlert());
};
